const ContentSideBar = ({ openModal, event }: any) => {
  return (
    <div
      className={`w-full text-left ${
        event?.replay_videos?.length > 1 ? "" : "mt-14"
      } max-sm:w-full`}
    >
      <h1 className="text-[32px] font-bold leading-tight tracking-[-0.01em] text-white max-sm:text-[24px]">
        {event?.title}
      </h1>

      <div className="mt-3 flex flex-wrap items-center gap-2">
        {event?.category && (
          <span className="rounded-full border border-white/10 bg-white/[0.06] px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-white/80">
            {event?.category}
          </span>
        )}
        {event?.duration && (
          <span className="rounded-full border border-[#f30543]/25 bg-[#f30543]/10 px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-[#ff5f80]">
            {event?.duration}
          </span>
        )}
      </div>

      {event?.description && (
        <div className="mt-6 max-w-[90%] rounded-2xl border border-white/10 bg-white/[0.03] p-4 max-sm:max-w-full">
          <p className="text-[14px] font-normal leading-relaxed text-white/75">
            {event?.description}
          </p>
        </div>
      )}
    </div>
  );
};

export default ContentSideBar;
